/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import mutationError from './mutationError';
import { ActionDef, AddonDef, ChannelDef, EntityDef, EntityViewDef, FlowDef, GroupDef, ScenarioDef, ScreenDef } from '../../common/types/types';

interface ValidateDefinitionMutationProps {
    actionDef?: ActionDef;
    addonDef?: AddonDef;
    channelDef?: ChannelDef;
    entityDef?: EntityDef;
    entityViewDef?: EntityViewDef;
    flowDef?: FlowDef;
    groupDef?: GroupDef;
    scenarioDef?: ScenarioDef;
    screenDef?: ScreenDef;
}

export default class ValidateDefinitionMutation extends Relay.Mutation<ValidateDefinitionMutationProps> {
    static propTypes = {
        actionDef: PropTypes.object,
        addonDef: PropTypes.object,
        channelDef: PropTypes.object,
        entityDef: PropTypes.object,
        entityViewDef: PropTypes.object,
        flowDef: PropTypes.object,
        groupDef: PropTypes.object,
        scenarioDef: PropTypes.object,
        screenDef: PropTypes.object,
    };

    getMutation() {
        return Relay.QL`mutation {validateDefinition}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on ValidateDefinitionPayload {
                success,
                messages {
                    id,
                    type,
                    action,
                    msg
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            actionDef_id: this.props.actionDef ? this.props.actionDef.id : null,
            addonDef_id: this.props.addonDef ? this.props.addonDef.id : null,
            channelDef_id: this.props.channelDef ? this.props.channelDef.id : null,
            flowDef_id: this.props.flowDef ? this.props.flowDef.id : null,
            scenarioDef_id: this.props.scenarioDef ? this.props.scenarioDef.id : null,
            screenDef_id: this.props.screenDef ? this.props.screenDef.id : null,
            groupDef_id: this.props.groupDef ? this.props.groupDef.id : null,
            entityDef_id: this.props.entityDef ? this.props.entityDef.id : null,
            entityViewDef_id: this.props.entityViewDef ? this.props.entityViewDef.id : null,
        };
    }
}

export function invokeValidation(relay, saveValidationResult, args) {
    return new Promise((resolve, reject) => {
		let onSuccess = (response) => {
			saveValidationResult({
				success: response.validateDefinition.success,
				messages: response.validateDefinition.messages
			});

			resolve();
		};

		let onFailure = (transaction) => {
			mutationError(transaction);

			reject();
		};

		relay.commitUpdate(
			new ValidateDefinitionMutation(args), {onSuccess: onSuccess, onFailure: onFailure}
		);
	});
}
